import formName from 'constants/formName'
import { actions } from 'data'
import { notifyError, notifySuccess } from 'data/App/sagas'
import { TwoFactorFormType } from 'data/types'
import { call, put } from 'redux-saga/effects'
import { enable2FA } from 'services/api/user'
import { Response } from 'utils/fetchApi'

import { goToStep } from './common'

export default function* enableTotpStep(form: TwoFactorFormType) {
  const data: Response<void> = yield call(enable2FA, {
    code: form.twoFactorCode,
    emailCode: form.emailCode,
    type: 'TOTP'
  })

  yield put(actions.form.change(formName.TWO_FACTOR, 'loading', false))

  if (!data.ok) {
    yield call(notifyError, data.error.cause, 'KO_VERIFY_TOTP')
    return
  }

  yield call(notifySuccess, 'OK_VERIFY_TOTP')

  yield call(goToStep, 'enablesuccess')
}
